var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoupcomingposts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 610.42 334.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 187.31,
    y: 306.05,
    width: 107.7,
    height: 27.89,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.31,
    y: 257.1,
    width: 230.66,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.04,
    y: 282.07,
    width: 22,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.31,
    y: 153.03,
    width: 317.51,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.31,
    y: 100.03,
    width: 226.51,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.38,
    y: 48.03,
    width: 268.44,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.38,
    y: 0.03,
    width: 175.66,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.82,
    y: 48.03,
    width: 19.81,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.03,
    y: 178.03,
    width: 42,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.31,
    cy: 320.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.31,
    cy: 320.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.31,
    cy: 271.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.04,
    cy: 271.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.04,
    cy: 296.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.97,306.05c-5.72,0-10.35-4.69-10.35-10.47s4.63-10.47,10.35-10.47c.12,0,.23.01.35.02v-7.55h-82.98v7.36c.43-.05.86-.08,1.3-.08,5.72,0,10.35,4.8,10.35,10.74s-4.63,10.74-10.35,10.74c-.44,0-.87-.03-1.3-.08v.33h82.98v-.55c-.12,0-.23.01-.35.01Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.04,
    cy: 296.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.82,
    cy: 243.1,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.38,
    cy: 220,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,177v3.97c6.9,0,12.5,5.61,12.5,12.53s-5.6,12.53-12.5,12.53v.97h320.64v-30H145.38Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.53,228.6v5.42c.12,0,.24-.02.37-.02,6.38,0,11.55,5.17,11.55,11.55s-5.17,11.55-11.55,11.55c-.12,0-.25-.01-.37-.02v.52h272v-29H183.53Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.37,229.07c-6.38,0-11.55-5.17-11.55-11.55,0-6.03,4.61-10.97,10.5-11.5H131.38v27.95h296.44v-5.17c-.79.18-1.61.27-2.45.27Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.82,206.24v-.21h-1.4c.48.04.94.11,1.4.21Z",
    fill: "#44bac5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 466.03,
    cy: 192,
    r: 15,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510.03,
    cy: 192,
    r: 14,
    transform: "translate(238.81 664.69) rotate(-80.78)",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552.03,
    cy: 192,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.31,
    cy: 167,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.31,
    cy: 114,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.38,
    cy: 62,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.28,48.03c-5.53,0-10.01-4.48-10.01-10.01s4.48-10.01,10.01-10.01c.26,0,.51.02.76.04v-5.04h-117.46v5.01c5.36.19,9.64,4.59,9.64,10s-4.28,9.82-9.64,10.01v2.93h117.46v-2.96c-.25,0-.5.03-.76.03Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.38,
    cy: 14,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.04,
    cy: 14,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.82,
    cy: 62,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.82,
    cy: 62,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.63,
    cy: 62,
    r: 14,
    fill: "#44bac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M594.21,233.35v-9c0-1.1.9-2,2-2h0c1.1,0,2,.9,2,2v9h-4Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.21,248.77v-9h4v9c0,1.1-.9,2-2,2h0c-1.11,0-2-.9-2-2Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.42,234.56h9c1.1,0,2,.9,2,2h0c0,1.1-.9,2-2,2h-9v-4Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584,234.56h9v4h-9c-1.1,0-2-.9-2-2h0c0-1.1.9-2,2-2Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.21,233.35v-9c0-1.1.9-2,2-2h0c1.1,0,2,.9,2,2v9h-4Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.21,248.77v-9h4v9c0,1.1-.9,2-2,2h0c-1.11,0-2-.9-2-2Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.42,234.56h9c1.1,0,2,.9,2,2h0c0,1.1-.9,2-2,2h-9v-4Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,234.56h9v4H2c-1.1,0-2-.9-2-2h0c0-1.1.9-2,2-2Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M543.77,315.9v-7.93c0-.64.52-1.16,1.16-1.16h.99c.64,0,1.16.52,1.16,1.16v7.93h-3.31Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.77,329.14v-7.93h3.31v7.93c0,.64-.52,1.16-1.16,1.16h-.99c-.64,0-1.16-.52-1.16-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.08,316.9h7.93c.64,0,1.16.52,1.16,1.16v.99c0,.64-.52,1.16-1.16,1.16h-7.93v-3.31Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.84,316.9h7.93v3.31h-7.93c-.64,0-1.16-.52-1.16-1.16v-.99c0-.64.52-1.16,1.16-1.16Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.8,315.9v-7.93c0-.64.52-1.16,1.16-1.16h.99c.64,0,1.16.52,1.16,1.16v7.93h-3.31Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8,329.14v-7.93h3.31v7.93c0,.64-.52,1.16-1.16,1.16h-.99c-.64,0-1.16-.52-1.16-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.11,316.9h7.93c.64,0,1.16.52,1.16,1.16v.99c0,.64-.52,1.16-1.16,1.16h-7.93v-3.31Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.87,316.9h7.93v3.31h-7.93c-.64,0-1.16-.52-1.16-1.16v-.99c.01-.64.52-1.16,1.16-1.16Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M527.36,42.58v-7.24c0-.64.52-1.16,1.16-1.16h.74c.64,0,1.16.52,1.16,1.16v7.24h-3.06Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.36,54.72v-7.24h3.05v7.24c0,.64-.52,1.16-1.16,1.16h-.74c-.64-.01-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.33,43.5h7.24c.64,0,1.16.52,1.16,1.16v.74c0,.64-.52,1.16-1.16,1.16h-7.24v-3.06Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.19,43.5h7.24v3.05h-7.24c-.64,0-1.16-.52-1.16-1.16v-.74c0-.63.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.04,42.58v-7.24c0-.64.52-1.16,1.16-1.16h.74c.64,0,1.16.52,1.16,1.16v7.24h-3.06Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.04,54.72v-7.24h3.05v7.24c0,.64-.52,1.16-1.16,1.16h-.74c-.64-.01-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.01,43.5h7.24c.64,0,1.16.52,1.16,1.16v.74c0,.64-.52,1.16-1.16,1.16h-7.24v-3.06Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.87,43.5h7.24v3.05h-7.24c-.64,0-1.16-.52-1.16-1.16v-.74c.01-.63.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M488.07,105.86v-5.75c0-.64.52-1.16,1.16-1.16h.2c.64,0,1.16.52,1.16,1.16v5.75h-2.52Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.07,115.64v-5.75h2.51v5.75c0,.64-.52,1.16-1.16,1.16h-.2c-.63,0-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.34,106.62h5.75c.64,0,1.16.52,1.16,1.16v.2c0,.64-.52,1.16-1.16,1.16h-5.75v-2.52Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.55,106.62h5.75v2.51h-5.75c-.64,0-1.16-.52-1.16-1.16v-.2c.01-.64.53-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.39,105.86v-5.75c0-.64.52-1.16,1.16-1.16h.2c.64,0,1.16.52,1.16,1.16v5.75h-2.52Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39,115.64v-5.75h2.51v5.75c0,.64-.52,1.16-1.16,1.16h-.2c-.64,0-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.66,106.62h5.75c.64,0,1.16.52,1.16,1.16v.2c0,.64-.52,1.16-1.16,1.16h-5.75v-2.52Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.87,106.62h5.75v2.51h-5.75c-.64,0-1.16-.52-1.16-1.16v-.2c.01-.64.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M556.35,147.28v-8.26c0-.64.52-1.16,1.16-1.16h1.11c.64,0,1.16.52,1.16,1.16v8.26h-3.43Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.35,161.03v-8.26h3.42v8.26c0,.64-.52,1.16-1.16,1.16h-1.11c-.63,0-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.81,148.31h8.26c.64,0,1.16.52,1.16,1.16v1.11c0,.64-.52,1.16-1.16,1.16h-8.26v-3.43Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.06,148.31h8.26v3.42h-8.26c-.64,0-1.16-.52-1.16-1.16v-1.11c0-.63.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.17,147.28v-8.26c0-.64.52-1.16,1.16-1.16h1.11c.64,0,1.16.52,1.16,1.16v8.26h-3.43Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,161.03v-8.26h3.42v8.26c0,.64-.52,1.16-1.16,1.16h-1.11c-.64,0-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.62,148.31h8.26c.64,0,1.16.52,1.16,1.16v1.11c0,.64-.52,1.16-1.16,1.16h-8.26s0-3.43,0-3.43Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.87,148.31h8.26v3.42h-8.26c-.64,0-1.16-.52-1.16-1.16v-1.11c.01-.63.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M285.78,143.02h2.52v14.55h7.58v2.17h-10.1v-16.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.99,153.52c0-3.9,2.31-6.49,5.85-6.49s5.84,2.59,5.84,6.49-2.31,6.47-5.84,6.47-5.85-2.59-5.85-6.47ZM307.22,153.51c0-2.4-1.08-4.44-3.37-4.44s-3.39,2.04-3.39,4.44,1.08,4.42,3.39,4.42c2.29,0,3.37-2.01,3.37-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.41,147.2h2.36v1.99h.13c.46-1.35,1.71-2.18,3.18-2.18.31,0,.79.02,1.04.06v2.33c-.2-.06-.77-.15-1.27-.15-1.73,0-3,1.18-3,2.82v7.66h-2.44v-12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.23,153.55c0-3.85,2.3-6.51,5.8-6.51,2.84,0,5.55,1.77,5.55,6.3v.87h-8.91c.06,2.42,1.47,3.77,3.56,3.77,1.39,0,2.45-.6,2.89-1.79l2.31.42c-.55,2.04-2.49,3.39-5.22,3.39-3.71-.01-5.98-2.56-5.98-6.45ZM329.18,152.37c-.01-1.92-1.25-3.32-3.14-3.32s-3.27,1.54-3.37,3.32h6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.3,147.2h2.34v2.04h.16c.52-1.38,1.75-2.2,3.41-2.2s2.83.83,3.37,2.2h.13c.6-1.34,1.96-2.2,3.76-2.2,2.27,0,3.87,1.43,3.87,4.29v8.41h-2.44v-8.18c0-1.7-1.06-2.42-2.35-2.42-1.59,0-2.51,1.09-2.51,2.6v7.99h-2.43v-8.33c0-1.36-.94-2.26-2.29-2.26s-2.57,1.18-2.57,2.87v7.73h-2.44v-12.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,159.74h-2.52v-16.72h2.52v16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.91,147.2h2.38v2.03h.2c.43-.78,1.27-2.2,3.6-2.2,3.03,0,5.26,2.39,5.26,6.46s-2.2,6.49-5.24,6.49c-2.29,0-3.18-1.4-3.62-2.2h-.15v6.65h-2.44v-17.23h0ZM372.58,157.9c2.18,0,3.32-1.92,3.32-4.43s-1.11-4.36-3.32-4.36-3.27,1.74-3.27,4.36,1.17,4.43,3.27,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.29,150.65c-.29-.84-.99-1.68-2.51-1.68-1.39,0-2.43.69-2.42,1.65-.01.85.59,1.31,1.97,1.64l1.99.46c2.3.53,3.43,1.62,3.43,3.4,0,2.27-2.1,3.88-5.13,3.88-2.82,0-4.66-1.25-5.07-3.47l2.36-.36c.29,1.23,1.23,1.86,2.69,1.86,1.6,0,2.64-.76,2.64-1.73,0-.78-.56-1.32-1.77-1.59l-2.12-.47c-2.35-.52-3.43-1.71-3.43-3.49,0-2.22,2.01-3.71,4.84-3.71s4.24,1.27,4.74,3.22l-2.21.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.38,147.2h2.45v12.54h-2.4v-2.17h-.13c-.58,1.34-1.86,2.33-3.75,2.33-2.41,0-4.11-1.62-4.11-4.73v-7.98h2.44v7.68c0,1.71,1.04,2.8,2.55,2.8,1.37,0,2.96-1.01,2.95-3.14v-7.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.11,147.2h2.34v2.04h.16c.52-1.38,1.75-2.2,3.41-2.2s2.83.83,3.37,2.2h.13c.6-1.34,1.96-2.2,3.76-2.2,2.27,0,3.87,1.43,3.87,4.29v8.41h-2.44v-8.18c0-1.7-1.06-2.42-2.35-2.42-1.59,0-2.51,1.09-2.51,2.6v7.99h-2.43v-8.33c0-1.36-.94-2.26-2.29-2.26s-2.57,1.18-2.57,2.87v7.73h-2.44v-12.54h0Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.79,257.38h-226.07c-6.35,0-12.85-.1-13.41-6.02l9.14-131.66,1.98-33.63c-.63-6.71,13.68-12.48,20.86-12.48h.09l187,1.26c6.16.04,11.33,4.37,12.07,10.11l3.01,23.45,17.49,136.12c.87,6.84-4.82,12.85-12.16,12.85Z",
    fill: "#222931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.79,257.38h-192.35c-6.35,0-11.64-4.54-12.2-10.47l-13.05-138.5-2.1-22.33c-.63-6.71,5.02-12.48,12.19-12.48h.09l187,1.26c6.16.04,11.33,4.37,12.07,10.11l3.01,23.45,17.49,136.12c.88,6.83-4.81,12.84-12.15,12.84Z",
    fill: "#c8dee6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.19,253.7h-186.08c-6.14,0-11.26-4.45-11.8-10.26l-12.62-135.72-2.03-21.89c-.61-6.58,4.85-12.23,11.8-12.23h.09l180.9,1.23c5.96.04,10.96,4.28,11.67,9.9l2.92,22.98,16.92,133.39c.83,6.7-4.67,12.6-11.77,12.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.03,107.72h-205.34l-2.03-21.89c-.61-6.58,4.85-12.23,11.8-12.23h.09l180.9,1.23c5.96.04,10.96,4.28,11.67,9.9l2.91,22.99Z",
    fill: "#96d2d9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.58,134.4l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.92,134.4l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,134.4l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.36,134.4l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.33,123.96l-.63-3.76c-.1-.27.65-.5,1.62-.5h14.28c.83,0,1.54.17,1.62.4l.63,3.76c.1.27-.65.5-1.62.5h-14.28c-.83,0-1.53-.17-1.62-.4Z",
    fill: "#d2e1e4",
    isolation: "isolate",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.15,129.39l-.63-3.76c-.1-.27.65-.5,1.62-.5h14.28c.83,0,1.54.17,1.62.4l.63,3.76c.1.27-.65.5-1.62.5h-14.28c-.83,0-1.53-.17-1.62-.4Z",
    fill: "#d2e1e4",
    isolation: "isolate",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.07,135.01l-.63-3.76c-.1-.27.65-.5,1.62-.5h14.28c.83,0,1.54.17,1.62.4l.63,3.76c.1.27-.65.5-1.62.5h-14.28c-.83,0-1.53-.17-1.62-.4Z",
    fill: "#d2e1e4",
    isolation: "isolate",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.66,146.74l-.63-3.76c-.1-.27.65-.5,1.62-.5h14.28c.83,0,1.54.17,1.62.4l.63,3.76c.1.27-.65.5-1.62.5h-14.28c-.83,0-1.53-.18-1.62-.4Z",
    fill: "#d2e1e4",
    isolation: "isolate",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.47,152.16l-.63-3.76c-.1-.27.65-.5,1.62-.5h14.28c.83,0,1.54.17,1.62.4l.63,3.76c.1.27-.65.5-1.62.5h-14.27c-.84.01-1.54-.17-1.63-.4Z",
    fill: "#d2e1e4",
    isolation: "isolate",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,157.79l-.63-3.76c-.1-.27.65-.5,1.62-.5h14.28c.83,0,1.54.17,1.62.4l.63,3.76c.1.27-.65.5-1.62.5h-14.28c-.83,0-1.53-.18-1.62-.4Z",
    fill: "#d2e1e4",
    isolation: "isolate",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.85,134.4l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.99,134.4l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.73,156.99l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.07,156.99l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.27c-.84,0-1.54-.6-1.63-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.52,156.99l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.33,156.99l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,156.99l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.14,156.99l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.3,180.54l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.84,0-1.54-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.64,180.54l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.54-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.51,180.54l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.08,180.54l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.89,180.54l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.56,180.54l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.7,180.54l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.45,203.13l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.79,203.13l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.66,203.13l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.24,203.13l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.84,0-1.54-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.05,203.13l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.72,203.13l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.86,203.13l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,226.68l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.84,0-1.54-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.43,226.68l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.54-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,226.68l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.87,226.68l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.68,226.68l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.35,226.68l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.49,226.68l-1.47-12.98c-.1-.92.65-1.72,1.62-1.72h14.28c.83,0,1.54.6,1.62,1.39l1.47,12.98c.1.92-.65,1.72-1.62,1.72h-14.28c-.83,0-1.53-.6-1.62-1.39Z",
    fill: "#d2e1e4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,81.93c5.77,0,10.45-4.44,10.45-9.91s-4.68-9.91-10.45-9.91-10.44,4.44-10.44,9.91c0,.57.02,1.05.02,1.62",
    fill: "none",
    stroke: "#222931",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.36,82.19c5.77,0,10.45-4.44,10.45-9.91s-4.68-9.91-10.45-9.91-10.44,4.44-10.44,9.91c0,.57.02,1.05.02,1.62",
    fill: "none",
    stroke: "#222931",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44,82.36c5.77,0,10.45-4.44,10.45-9.91s-4.68-9.91-10.45-9.91-10.44,4.44-10.44,9.91c0,.57.02,1.05.02,1.62",
    fill: "none",
    stroke: "#222931",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.81,82.6c5.77,0,10.45-4.44,10.45-9.91s-4.68-9.92-10.45-9.92-10.44,4.44-10.44,9.91c0,.57.02,1.05.02,1.62",
    fill: "none",
    stroke: "#222931",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.98,82.89c5.77,0,10.45-4.44,10.45-9.91s-4.68-9.91-10.45-9.91-10.44,4.44-10.44,9.91c0,.57.02,1.05.02,1.62",
    fill: "none",
    stroke: "#222931",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoupcomingposts);
export default __webpack_public_path__ + "static/media/No upcoming posts.f1bb39d49dc122cba85af43ab5c21314.svg";
export { ForwardRef as ReactComponent };